module.exports = __webpack_public_path__ + "img/shelf-life-white.809573e2.svg";